import  employeeCostActions from './employee-costs'

const actions = {
  ...employeeCostActions
}

export default actions
